export default __webpack_public_path__ + "static/media/Guia.652a916f.png";